import { Snackbar, Alert } from '@mui/material';
import { heritageColors } from '../../heritageTheme.ts';

/**
 * Toast - קומפוננטת הודעות טוסט
 * 
 * Dummy Component - presentational only
 * 
 * @param {boolean} open - האם הטוסט פתוח
 * @param {string} message - הודעה להצגה
 * @param {string} severity - סוג ההודעה: 'success' | 'error' | 'warning' | 'info'
 * @param {function} onClose - callback לסגירת הטוסט
 * @param {number} autoHideDuration - זמן להסתרה אוטומטית (ברירת מחדל: 4000ms)
 * @param {string} position - מיקום הטוסט: 'top' | 'bottom' (ברירת מחדל: 'top')
 */
const Toast = ({
    open,
    message,
    severity = 'success',
    onClose,
    autoHideDuration = 4000,
    position = 'top'
}) => {
    return (
        <Snackbar
            open={open}
            autoHideDuration={autoHideDuration}
            onClose={onClose}
            anchorOrigin={{ vertical: position, horizontal: 'center' }}
        >
            <Alert
                onClose={onClose}
                severity={severity}
                variant="filled"
                sx={{
                    minWidth: '300px',
                    fontSize: '1rem',
                    fontWeight: 500,
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                    flexDirection: 'row-reverse',
                    bgcolor: heritageColors.teal,
                    color: 'white',
                    '& .MuiAlert-message': {
                        textAlign: 'right',
                        width: '100%'
                    },
                    '& .MuiAlert-icon': {
                        color: 'white'
                    }
                }}
            >
                {message}
            </Alert>
        </Snackbar>
    );
};

export default Toast;
